import { render, staticRenderFns } from "./power.vue?vue&type=template&id=64926fcc&scoped=true"
var script = {}
import style0 from "./power.vue?vue&type=style&index=0&id=64926fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64926fcc",
  null
  
)

export default component.exports